import { PageContainer } from '@amelio/ui-library';

import { EmptyState } from '@/components/EmptyState/EmptyState';
import { useAmelioTranslations } from '@/hooks';

interface UnavailableStateProps {
    /** What could not be read, named to the reader. */
    title: string;
    message: string;
    /** Asks again for what failed. */
    onRetry: () => void;
}

/**
 * What a screen shows once the read that decides its content has failed. An outage says nothing
 * about what the reader may see, so they are offered another try rather than an empty page or a
 * verdict they would have no reason to question.
 */
export const UnavailableState = ({ title, message, onRetry }: UnavailableStateProps) => {
    const { t } = useAmelioTranslations();

    return (
        <PageContainer>
            <EmptyState
                title={title}
                message={message}
                action={{ label: t('errors.retry'), onClick: onRetry }}
            />
        </PageContainer>
    );
};
